import { createContext, useContext, useState, useEffect } from "react";
import API from "../api/api";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [token, setToken] = useState(null);

  // ================= INIT =================
  useEffect(() => {
    const access = localStorage.getItem("access");
    const role = localStorage.getItem("user_role");

    if (access && role) {
      setIsAuthenticated(true);
      setUserRole(role);
      setToken(access);
      fetchCurrentUser(access);
    }
  }, []);

  // ================= FETCH CURRENT USER =================
  const fetchCurrentUser = async (accessToken) => {
    try {
      const res = await API.get("auth/me/", {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      setCurrentUser(res.data); // { username, phone, email, ... }
    } catch (err) {
      console.error("Failed to fetch user:", err);
      setCurrentUser(null);
      setIsAuthenticated(false);
      setToken(null);
    }
  };

  // ================= LOGIN =================
  const login = async (access, refresh, role) => {
    localStorage.setItem("access", access);
    localStorage.setItem("refresh", refresh);
    localStorage.setItem("user_role", role);

    setIsAuthenticated(true);
    setUserRole(role);
    setToken(access);
    await fetchCurrentUser(access); // await ensures data is ready before navigation
  };

  // ================= LOGOUT =================
  const logout = () => {
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    localStorage.removeItem("user_role");

    setIsAuthenticated(false);
    setUserRole(null);
    setCurrentUser(null);
    setToken(null);
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        userRole,
        currentUser,
        token,
        login,     // <--- updated function!
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}